// material-ui
import { Box, List, Typography } from '@mui/material';
import { useTheme } from '@mui/material/styles';

// project import
import { useIsAdmin } from '../../../../../hooks/useUserAuth';
import NavCollapse from './NavCollapse';
import NavItem from './NavItem';

// ==============================|| NAVIGATION - LIST GROUP ||============================== //

const NavGroup = ({ item, featureFlags }) => {
  const theme = useTheme();
  const { isAdmin } = useIsAdmin(); // use the hook to get the isAdmin value

  const navCollapse = item.children?.map((menuItem) => {
    const itemFeatureFlag = featureFlags[menuItem.id];
    //Filter by feature flag
    if (typeof itemFeatureFlag !== 'undefined' && !itemFeatureFlag) return null;
    // check if the collapse is admin-only and the user is not an admin
    if (menuItem.isAdminOnly && !isAdmin) {
      return null; // return null to not render the collapse
    }
    switch (menuItem.type) {
      case 'collapse':
        return <NavCollapse key={menuItem.id} menu={menuItem} level={1} />;
      case 'item':
        return <NavItem key={menuItem.id} item={menuItem} level={1} />;
      default:
        return (
          <Typography key={menuItem.id} variant="h6" color="error" align="center">
            Fix - Group Collapse or Items
          </Typography>
        );
    }
  });

  return (
    <List
      subheader={
        item.title && (
          <Box sx={{ pl: 3, mb: 1.5 }}>
            <Typography variant="subtitle2" color={theme.palette.mode === 'dark' ? 'textSecondary' : 'text.secondary'}>
              {item.title}
            </Typography>
            {item.caption && (
              <Typography variant="caption" color="secondary">
                {item.caption}
              </Typography>
            )}
          </Box>
        )
      }
      sx={{ 1.5: 0, py: 0, zIndex: 0 }}
    >
      {navCollapse}
    </List>
  );
};

export default NavGroup;
